import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HPControlGlyph = /*#__PURE__*/createElement("g", {
  id: "hp_control"
}, /*#__PURE__*/createElement("path", {
  d: "M66.67 54.42v5.83H17.33v-5.83h49.34m3-3H14.33v11.83h55.33V51.42h.01z"
}), /*#__PURE__*/createElement("path", {
  d: "M14.33 49.12h3.69v16.43h-3.69zm51.65 0h3.69v16.43h-3.69zm-24.05-.13c-8.83 0-16.01-7.18-16.01-16.01s7.18-16.01 16.01-16.01 16.02 7.18 16.02 16.01-7.19 16.01-16.02 16.01zm0-29.03c-7.18 0-13.01 5.84-13.01 13.01s5.84 13.01 13.01 13.01 13.02-5.84 13.02-13.01-5.84-13.01-13.02-13.01z"
}), /*#__PURE__*/createElement("path", {
  d: "M44.33 43.61l-.44-1.95c.17-.04.33-.08.5-.13.5-.14.99-.33 1.46-.56l.88 1.8c-.57.28-1.17.51-1.78.68-.21.06-.42.11-.62.16zm-5.02-.05c-.82-.21-1.62-.5-2.37-.89l.92-1.78c.61.32 1.26.56 1.93.73l-.48 1.94zm11.3-3.98l-1.59-1.21c.42-.55.77-1.15 1.05-1.78l1.83.81c-.35.77-.78 1.51-1.29 2.18zm-17.49-.18c-.5-.68-.92-1.43-1.24-2.21l1.85-.77c.27.64.61 1.24 1.01 1.8l-1.62 1.18zm17.71-6.84a8.79 8.79 0 00-.34-2.04l1.92-.57.01.04c.23.79.37 1.63.41 2.47l-2 .1zm-17.78-.19l-2-.14c.06-.84.21-1.68.46-2.49l1.91.59c-.2.67-.33 1.35-.37 2.04zm15.41-5.45c-.47-.5-1-.96-1.57-1.34L48 23.91c.7.47 1.35 1.02 1.92 1.64l-1.46 1.37zm-12.95-.12l-1.44-1.38c.59-.61 1.24-1.15 1.95-1.61l1.08 1.68c-.57.37-1.11.81-1.59 1.31zm7.53-2.67c-.37-.05-.74-.07-1.11-.07-.29 0-.64.02-.96.05l-.22-1.99c.39-.04.81-.06 1.18-.06.45 0 .91.03 1.36.09l-.25 1.98z"
}), /*#__PURE__*/createElement("circle", {
  cx: 42.01,
  cy: 35.23,
  r: 2.34
}), /*#__PURE__*/createElement("path", {
  d: "M43.41 33.32H40.6l.63-4.37c.04-.34.35-2.65.7-2.65h.15c.35 0 .66 2.3.7 2.65l.63 4.37zm-5.26 14.25h7.57v5.36h-7.57z"
}));
const HPControl = createSvg({
  name: 'hp_control',
  path: HPControlGlyph
});

export default HPControl;
export { HPControlGlyph };
